import axios from "axios";
import { API } from "./api";

export function getDeviceId() {
  let id = localStorage.getItem('device_id');
  if (!id) { id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`); localStorage.setItem('device_id', id); }
  return id;
}

function b64ToUint8(base64) {
  const padding = '='.repeat((4 - base64.length % 4) % 4);
  const b = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(b);
  return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
}

export function pushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Notifications aren't supported on this device/browser");
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Notification permission was denied');
  const reg = await navigator.serviceWorker.ready;
  const { data } = await axios.get(`${API}/push/vapid-public-key`);
  const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(data.key) });
  await axios.post(`${API}/push/subscribe`, { device_id: getDeviceId(), subscription: sub.toJSON(), order_alerts: localStorage.getItem('order_alerts') === 'on' });
  localStorage.setItem('notifications_enabled', 'on');
}

export async function disablePush() {
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) await sub.unsubscribe();
  } catch { /* ignore */ }
  try { await axios.post(`${API}/push/unsubscribe`, { device_id: getDeviceId() }); } catch { /* ignore */ }
  localStorage.setItem('notifications_enabled', 'off');
}

export async function setOrderAlerts(on) {
  localStorage.setItem('order_alerts', on ? 'on' : 'off');
  try { await axios.put(`${API}/push/settings`, { device_id: getDeviceId(), order_alerts: on }); } catch { /* ignore */ }
}
